var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIceHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Ice_Hockey_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ice_Hockey_",
    "data-name": "Ice Hockey ",
    clipPath: "url(#clip-Ice_Hockey_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M-8339.653-7576.641l-2.938,1.937-6.229,6.438-5.565,5.486-4.066,4.244.178,1.194,1.337,1.656,1.572,1.586,1.112.695h1.062l1.371-.1,1.21-.6,3.909-2.069,2.957-2.368,1.973-1.974,2.119-2.27,1.908-2.429,1.006-1.782.892-1.888.662-1.658v-1.027l-.662-1.258-2.9-3.011Z",
    transform: "translate(8360.586 7578.881)",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 13.5,
    cy: 4.5,
    rx: 13.5,
    ry: 4.5,
    transform: "translate(-2.077 17.303) rotate(-45)",
    fill: "#010202",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M388,659.551s3.069,3.059,4.826,4.817-1.092,7.456-6.364,12.728-11.445,7.871-13.2,6.113-4.365-4.642-4.365-4.642",
    transform: "translate(-367.907 -658.254)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceHockey);
export default __webpack_public_path__ + "static/media/IceHockey.9744c1377ffe1557052dc9cd125ac368.svg";
export { ForwardRef as ReactComponent };